import { Injectable, inject } from '@angular/core';

import { ClientConfig, ClientConfigProductName, ClientConfigService, StylesService } from '@frontend/vanilla/core';

@ClientConfig({ key: 'paAssets', product: ClientConfigProductName.PAYMENTS })
@Injectable({
    providedIn: 'root',
    useFactory: AssetsDataFactory,
    deps: [ClientConfigService],
})
export class AssetsData {
    imageVariablesCSS!: string;
    assets!: {
        achInterchecks?: { [key: string]: string };
        brazilimages?: { [key: string]: string };
        footerlogos?: { [key: string]: string };
        managebankaccount?: { [key: string]: string };
        miscimages?: { [key: string]: string };
        transactionhistory?: { [key: string]: string };
        truelayerlogos?: { [key: string]: string };
        videos?: { [key: string]: string };
    };
}

export function AssetsDataFactory(clientConfigService: ClientConfigService) {
    const data = clientConfigService.get(AssetsData);
    const stylesService: StylesService = inject(StylesService);
    stylesService.addStyle('payments-image-variables', data.imageVariablesCSS);
    return data;
}

@ClientConfig({ key: 'paCashier', product: ClientConfigProductName.PAYMENTS })
@Injectable({
    providedIn: 'root',
    useFactory: PaymentsCashierConfigFactory,
    deps: [ClientConfigService],
})
export class PaymentsCashierConfig {
    host!: string;
    ngpgHost!: string;
}

export function PaymentsCashierConfigFactory(clientConfigService: ClientConfigService) {
    return clientConfigService.get(PaymentsCashierConfig);
}
